<div class="modal-header {{ dialogClass }}">
  <h4 class="modal-title float-left">
    Notifications
    <span *ngIf="unreadCount && unreadCount > 0">({{ unreadCount }})</span>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="closeClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div *ngIf="!notifications || notifications?.length === 0">
    <div class="ey-notifications-empty">There are no notifications to show.</div>
  </div>
  <div *ngIf="notifications?.length > 0">
    <table class="table table-sm">
      <tr *ngFor="let notification of notifications | sortDate: '-updatedDate'">
        <td class="ey-action-column">
          <button
            type="button"
            class="btn btn-link ey-notification-button"
            (click)="deleteNotification(notification.key)"
            title="Delete Notification"
          >
            <i class="material-icons">delete</i>
          </button>
          <button
            type="button"
            class="btn btn-link ey-notification-button"
            *ngIf="notification.isRead !== true"
            (click)="markNotificationRead(notification.key)"
            title="Mark as Read"
          >
            <i class="material-icons">notifications_active</i>
          </button>
          <button
            type="button"
            class="btn btn-link ey-notification-button"
            *ngIf="notification.isRead === true"
            (click)="markNotificationUnread(notification.key)"
            title="Mark as Unread"
          >
            <i class="material-icons">notifications_none</i>
          </button>
          <span *ngIf="notification.notificationType === reportNotification && !notification.isRequestCompleted" class="table-spinner-container">
            <p-progressSpinner strokeWidth="10"></p-progressSpinner>
          </span>
        </td>
        <td>
          <div
            class="ey-notification-message"
            [ngClass]="{
              'ey-notification-message-unread': notification.isRead !== true,
              'ey-notification-message-error': notification.isErrorMessage === true
            }"
          >
            <a *ngIf="notification.url" [href]="notification.url">{{ notification.message }}</a>
            <span *ngIf="!notification.url">{{ notification.message }}</span>
          </div>
        </td>
        <td *ngIf="notification.notificationType !== reportNotification">
          <div class="ey-notification-date">
            {{ notification.updatedDate | date: 'dd-MMM-yyyy' }},
            {{ notification.updatedDate | date: 'mediumTime' }}
          </div>
        </td>
        <td *ngIf="notification.notificationType === reportNotification">
          <div class="ey-notification-date">
            <span
              *ngIf="!notification.isRequestCompleted"
              style="display: inline-block"
              alt="Started at: {{ notification.createdDate | date: 'dd-MMM-yyyy' }},  {{ notification.createdDate | date: 'mediumTime' }}"
            >
              {{ notification.createdDate | timeago: live }}
            </span>
            <span
              *ngIf="notification.isRequestCompleted"
              style="display: inline-block"
              title="Completed in:  {{ notification.duration | date: 'mm:ss' }}"
            >
              Completed at: {{ notification.updatedDate | date: 'dd-MMM-yyyy' }}, {{ notification.updatedDate | date: 'mediumTime' }}
            </span>
          </div>
        </td>
      </tr>
    </table>

    <div class="row">
      <div class="col-sm-12">
        <button type="button" class="btn btn-default ey-notifications-button" (click)="deleteAllNotifications()">Delete All</button>
        <button type="button" class="btn btn-default ey-notifications-button" (click)="markAllNotificationsRead()">Mark As Read</button>
      </div>
    </div>
  </div>
  <div class="ey-notification-disclaimer">* Notifications are stored for each browser</div>

  <!-- ONLY FOR TESTING NOTIFICATIONS -->
  <div style="display: none">
    <div class="ey-notification-help">This is only for testing / demonstration of how the indicator and screen work</div>
    <form autocomplete="off" (ngSubmit)="addNotification(notificationForm)" id="notificationForm" #notificationForm="ngForm">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <span class="ey-float-label">
              <input
                type="text"
                class="form-control"
                id="notificationKey"
                name="notificationKey"
                [(ngModel)]="notification.key"
                required
                appLabelFloat
              />
              <label for="notificationKey">Notification Key</label>
            </span>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <span class="ey-float-label">
              <input
                type="text"
                class="form-control"
                id="notificationMessage"
                name="notificationMessage"
                [(ngModel)]="notification.message"
                required
                appLabelFloat
              />
              <label for="notificationMessage">Notification Message</label>
            </span>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <p-checkbox id="isErrorMessage" name="isErrorMessage" [(ngModel)]="notification.isErrorMessage" binary="true" #isErrorMessage="ngModel">
            </p-checkbox>
            <label class="form-check-label" for="isErrorMessage">Is Error Message?</label>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <span class="ey-float-label">
              <input type="text" class="form-control" id="notificationUrl" name="notificationUrl" [(ngModel)]="notification.url" appLabelFloat />
              <label for="notificationUrl">Notification Url</label>
            </span>
          </div>
        </div>
      </div>

      <div>
        <button type="submit" class="btn btn-primary">Add Notification</button>
      </div>
    </form>
  </div>
</div>
